export const DOCUMENT_SEARCH_TEXTS = {
  title: 'Recherche de documents',
  documentType: 'Type de document',
  searchField: 'Champ de recherche',
  searchValue: 'Valeur de recherche',
  searchButton: 'Rechercher',
  clearButton: 'Effacer les résultats',
  results: 'Résultats de recherche',
  noResults: 'Aucun résultat trouvé',
  loading: 'Recherche en cours...',
  errorSearching: 'Erreur lors de la recherche de documents',
  selectDocumentType: 'Sélectionnez un type de document',
  selectSearchField: 'Sélectionnez un champ de recherche',
  enterSearchValue: 'Entrez une valeur de recherche',

  // Document types
  documentTypes: {
    event: 'Événement',
    sensor: 'Capteur',
    location: 'Emplacement',
    alert: 'Alerte',
    user: 'Utilisateur',
    organization: 'Organisation'
  },

  // Search fields by document type
  searchFields: {
    event: {
      id: 'ID'
    },
    sensor: {
      id: 'ID',
      serialNumber: 'Numéro de série'
    },
    location: {
      id: 'ID'
    },
    alert: {
      id: 'ID'
    },
    user: {
      uid: 'ID Utilisateur'
    },
    organization: {
      id: 'ID'
    }
  }
} as const;
